import React, { useState } from "react";

export interface ITabPanelProps {
  children: React.ReactNode;
  index: number;
  value: number;
  className?: string;
  isPanelWithMount?: boolean;
  panelId: string;
  ariaLabelledById: string;
}

export const MuiTabPanel = React.memo((props: ITabPanelProps) => {
  const {
    children,
    value,
    index,
    className = "",
    panelId,
    isPanelWithMount = false,
    ariaLabelledById,
    ...rest
  } = props;

  // Track if the tab has been visited before
  const [isMounted, setIsMounted] = useState<boolean[]>([]);

  if (isPanelWithMount && !isMounted[index] && value === index) {
    setIsMounted((prev) => {
      const newState = [...prev];
      newState[index] = true;
      return newState;
    });
  }

  return (
    <div
      className={`Mui-tabpanel ${className}`}
      role="tabpanel"
      hidden={value !== index}
      id={panelId}
      aria-labelledby={ariaLabelledById}
      data-testid={`mui-tabpanel-${index}`}
      {...rest}
    >
      {isPanelWithMount
        ? isMounted[index] && children
        : value === index && <>{children}</>}
    </div>
  );
});
